// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../../../css-global/colors.scss\"","_grayDark":"#768d99","_white":"#ffffff","root":"UpdateFlag-module--root--3fj5Y"};